import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKofaxComponent } from './simple-icons-kofax.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKofaxComponent ],
    exports:      [ SimpleIconsKofaxComponent ],
    bootstrap:    []
})
export class SimpleIconsKofaxModule {}
